<div class="online-courses" *ngIf="courseDetails$ | async as courseDetails">
  <lx-online-course-selector-field
    [selectedValue]="courseDetails.selectedCourse"
    [selectedSchoolLocation]="courseDetails.selectedSchoolLocation"
    [currentDuration]="courseDetails.selectedDuration"
    [currentStartDate]="courseDetails.selectedStartDate"
    [disabled]="!courseDetails.selectedSchoolLocation"
    (selectedValueChange)="updateSelectedCourse($event)"
    (predefinedSelectionsChanged)="handlePredefinedSelections($event)"
  ></lx-online-course-selector-field>
  <lx-duration-selector-field
    [selectedValue]="courseDetails.selectedDuration"
    [disabled]="!courseDetails.selectedCourse"
    (selectedValueChange)="updateSelectedDuration($event)"
  ></lx-duration-selector-field>
  <lx-flexible-start-date-selector-field
    [disabled]="!courseDetails.selectedDuration"
    [selectedValue]="courseDetails.selectedStartDate"
    [selectedStartDate]="courseDetails.selectedStartDate"
    [selectedEndDate]="courseDetails.selectedEndDate"
    (selectedValueChange)="updateSelectedStartDate($event)"
    [calendarConfig]="calendarConfig"
  >
  </lx-flexible-start-date-selector-field>
  <lx-timezone-selector-field
    [disabled]="!courseDetails.selectedStartDate && !courseDetails.selectedEndDate"
    [selectedValue]="courseDetails.selectedTimezone"
    (selectedValueChange)="updateSelectedTimezone($event)"
  ></lx-timezone-selector-field>
  <lx-class-time-selector-field
    [disabled]="!courseDetails.selectedStartDate && !courseDetails.selectedEndDate"
    [selectedValue]="courseDetails.selectedClassTime"
    [selectedSchoolLocationAndCourseAndTimezone$]="selectedSchoolLocationAndCourseAndTimezone$"
    (selectedValueChange)="updateSelectedClassTime($event)"
  >
  </lx-class-time-selector-field>
</div>
